var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('ul',{staticClass:"menuList"},_vm._l((_vm.menuList),function(menu,idx){return _c('li',{key:idx},[_c('a',{attrs:{"href":menu.url,"target":/^https/.test(menu.url) ? '_blank' : false}},[_vm._v(_vm._s(menu.name))])])}),0),_vm._v(" "),_c('div',{staticClass:"inc"},[_vm._v("©ZAPPALLAS, INC. 2021")])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ecc8837c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/utvStore/components/Academy/partials/FooterAcademy.vue
// module id = null
// module chunks = 